export enum OverlayId {
  NONE = "NONE",
  LEADERBOARD_INFO_OVERLAY = "LEADERBOARD_INFO_OVERLAY",
  GAME_RESULT_OVERLAY = "GAME_RESULT_OVERLAY",
  CONTINUE_OVERLAY = "CONTINUE_OVERLAY",
  NEW_GOAL_OVERLAY = "NEW_GOAL_OVERLAY",
  NEW_BOOSTER_OVERLAY = "NEW_BOOSTER_OVERLAY",
  INFINITE_LIVES_OVERLAY = "INFINITE_LIVES_OVERLAY",
  SHOP_OVERLAY = "SHOP_OVERLAY",
  DAILY_TASKS_OVERLAY = "DAILY_TASKS_OVERLAY",
  ADVENTURE_INFO_OVERLAY = "ADVENTURE_INFO_OVERLAY",
  ADVENTURE_ENDED_OVERLAY = "ADVENTURE_ENDED_OVERLAY",
  DAILY_TASKS_ENDED_OVERLAY = "DAILY_TASKS_ENDED_OVERLAY",
  DAILY_CHALLENGE_INFO_OVERLAY = "DAILY_CHALLENGE_INFO_OVERLAY",
  FEATURE_TUTORIAL_OVERLAY = "FEATURE_TUTORIAL_OVERLAY",
  MYSTERY_BOX_OVERLAY = "MYSTERY_BOX_OVERLAY",
  TOURNAMENT_WIN_OVERLAY = "TOURNAMENT_WIN_OVERLAY",
  TOURNAMENT_REWARD_OVERLAY = "TOURNAMENT_REWARD_OVERLAY",
  KEY_HUNT_INFO_OVERLAY = "KEY_HUNT_INFO_OVERLAY",
  PRIZE_SHOT_REWARDS_OVERLAY = "PRIZE_SHOT_REWARDS_OVERLAY",
}
